<app-admin-card title="Funnel Insights" icon="sparkles" [span2]="true">
  @if (!hasData()) {
    <p class="dashboard-funnel-insights__empty">
      Funnel insights will appear once lead and applicant funnel data is available.
    </p>
  } @else {
    <div class="dashboard-funnel-insights__columns">
      <section class="dashboard-funnel-insights__column" aria-label="Lead funnel insights">
        <h3 class="dashboard-funnel-insights__column-title">Leads</h3>
        @if (leadInsights().length === 0) {
          <p class="dashboard-funnel-insights__empty">No lead funnel insights yet.</p>
        } @else {
          <div class="dashboard-funnel-insights__grid">
            @for (item of leadInsights(); track item.title + item.description) {
              <article class="dashboard-funnel-insights__item">
                <span class="dashboard-funnel-insights__icon" aria-hidden="true">
                  <app-admin-icon [name]="item.icon" [size]="18" />
                </span>
                <div>
                  <h4 class="dashboard-funnel-insights__title">{{ item.title }}</h4>
                  <p class="dashboard-funnel-insights__description">{{ item.description }}</p>
                </div>
              </article>
            }
          </div>
        }
      </section>

      <section class="dashboard-funnel-insights__column" aria-label="Applicant funnel insights">
        <h3 class="dashboard-funnel-insights__column-title">Applicants</h3>
        @if (applicantInsights().length === 0) {
          <p class="dashboard-funnel-insights__empty">No applicant funnel insights yet.</p>
        } @else {
          <div class="dashboard-funnel-insights__grid">
            @for (item of applicantInsights(); track item.title + item.description) {
              <article class="dashboard-funnel-insights__item">
                <span class="dashboard-funnel-insights__icon" aria-hidden="true">
                  <app-admin-icon [name]="item.icon" [size]="18" />
                </span>
                <div>
                  <h4 class="dashboard-funnel-insights__title">{{ item.title }}</h4>
                  <p class="dashboard-funnel-insights__description">{{ item.description }}</p>
                </div>
              </article>
            }
          </div>
        }
      </section>
    </div>
  }
</app-admin-card>
